import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, mergeMap, Observable } from 'rxjs';
import { CoursePreview, CoursePreviewDto } from '../models';
import { Pathway } from '../models/pathway';
import { PathwayDto } from '../models/pathway.dto';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getLibrary(pathId: number): Observable<CoursePreview[]> {
        return this.getPathway(pathId).pipe(mergeMap((pathway) => this.getCourses(pathway)));
    }

    private getPathway(pathId: number): Observable<Pathway> {
        return this.httpClient.get<PathwayDto>(`api/v1/pathways/${pathId}`).pipe(
            map((response) => new Pathway(response)),
            catchError(() => {
                throw new Error('no-content');
            }),
        );
    }

    private getCourses(pathway: Pathway): Observable<CoursePreview[]> {
        let params = new HttpParams();

        pathway.coursesIds.forEach((courseId) => {
            params = params.append('id[]', courseId);
        });

        return this.httpClient.get<CoursePreviewDto[]>('api/v1/library/courses', { params }).pipe(
            map((response) => {
                if (response.length === 0) {
                    throw new Error('no-content');
                }
                return response.map((course) => new CoursePreview(course));
            }),
        );
    }
}
